import React, { Component } from 'react';
import { Route } from 'react-router';

import { Home } from './components/Home';
import { Messages } from './components/Messages';

import { PrivateRoute } from './_privateroute';
import { Login } from './components/Login'
import { ExtApp } from './components/ExtApp';

export default class App extends Component {
    static displayName = App.name;

    render() {
        return (
            <div>
                <Route exact path='/' component={Login} />
                <Route exact path='/ext' component={ExtApp} />
                <PrivateRoute path="/home" component={Home} />
                <PrivateRoute path="/messages" component={Messages} />

            </div>
        );
    }
}
